module.exports = function() {
  return new Worker(__webpack_public_path__ + "12417e821cb8730fd511.worker.js");
};